export default "__VITE_ASSET__$z00V2X$__"